import { BCarousel } from './carousel';
import { BCarouselSlide } from './carousel-slide';
import { pluginFactory } from '../../utils/plugins';
var CarouselPlugin =
/*#__PURE*/
pluginFactory({
  components: {
    BCarousel: BCarousel,
    BCarouselSlide: BCarouselSlide
  }
});
export { CarouselPlugin, BCarousel, BCarouselSlide };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/carousel/index.js
// module id = 184
// module chunks = 0